<ng-container *ngIf="moveCode6111sLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_MC6'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="moveCode6111sError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_MC6'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="!moveCode6111sLoading && !moveCode6111sError">
	<div class="horizontal-scroll">
		<div class="flex justify-between items-center mb-3 px-2">
			<!-- Left: Create New button -->
			<button pButton type="button" icon="pi pi-plus"
				label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}"
				class="p-button-sm p-button-primary" (click)="createNewRecord()"></button>

			<!-- Right: Global filter -->
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
					placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}" class="p-inputtext-sm" />
			</span>
		</div>
		<p-table 
			#dt 
			id = "tab_mc_6111"
			[globalFilterFields]="globalFilterFields" 
			[value]="moveCode6111s" dataKey="RecID"
			[totalRecords] = "moveCode6111s.length"
			*ngIf="moveCode6111s && moveCode6111s.length > 0; else noMoveCode6111s"
			styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped" responsiveLayout="scroll" 
			[paginator]="true"
			[rows]="getCurrentPageSize(0, moveCode6111s.length)"
			[rowsPerPageOptions]="setPaginator(moveCode6111s.length)" 
			(onPage) = "onRowsPerPageChange($event,0 , moveCode6111s.length)"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_MC6S'] }}"
			[tableStyle]="{'min-width': '58rem', 'table-layout': 'auto'}" [paginatorDropdownAppendTo]="'body'">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === moveCode6111s.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="RecID">
						{{ translateServ.dictionary['MAINT_CS_TIT_ID'] || 'ID' }}
						<p-sortIcon field="RecID"></p-sortIcon>
					</th>
					<th pSortableColumn="Category">
						{{ translateServ.dictionary['MAINT_IN_TIT_EXP_CODE'] || 'Category' }}
						<p-sortIcon field="Category"></p-sortIcon>
					</th>
					<th pSortableColumn="IsActive">
						{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] || 'Status' }}
						<p-sortIcon field="IsActive"></p-sortIcon>
					</th>
					<th pSortableColumn="IsApproved">
						{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						<p-sortIcon field="IsApproved"></p-sortIcon>
					</th>
					<th pSortableColumn="Descr">
						{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						<p-sortIcon field="Descr"></p-sortIcon>
					</th>
					<th pSortableColumn="DateEntered">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_ENTERED'] || 'Created On' }}
						<p-sortIcon field="DateEntered"></p-sortIcon>
					</th>
					<th pSortableColumn="DateUpdated">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_UPDATED'] || 'Updated On' }}
						<p-sortIcon field="DateUpdated"></p-sortIcon>
					</th>
					<th>{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] || 'Actions' }}</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-moveCode6111Item>
				<tr>
					<td class="wrap-cell">{{ moveCode6111Item.RecID }}</td>
					<td class="wrap-cell">{{ moveCode6111Item.ExpenseCode }}</td>
					<td>
						<p-tag [value]="moveCode6111Item.IsActive === 1 ? 'Active' : 'Inactive'"
							[severity]="getMoveCode6111Severity(moveCode6111Item.IsActive)"
							(click)="toggleMoveCode6111Status(moveCode6111Item, true)"></p-tag>
					</td>
					<td>
						<p-tag
							[value]="moveCode6111Item.IsApproved === 1 ? (translateServ.dictionary['APPROVED'] || 'Approved') : (translateServ.dictionary['NOT_APPROVED'] || 'Not Approved')"
							[severity]="moveCode6111Item.IsApproved === 1 ? 'success' : 'warning'"
							(click)="toggleMoveCode6111Status(moveCode6111Item, false)">
						</p-tag>
					</td>
					<td class="wrap-cell">{{ moveCode6111Item.Descr || 'N/A' }}</td>
					<td class="wrap-cell">{{ moveCode6111Item.DateEntered ? (moveCode6111Item.DateEntered |
						date:'mediumDate') :
						'N/A' }}</td>
					<td class="wrap-cell">{{ moveCode6111Item.DateUpdated ? (moveCode6111Item.DateUpdated |
						date:'mediumDate') :
						'N/A' }}</td>

					<td>
						<div class="flex gap-2">
							<button pButton icon="pi pi-pencil" (click)="editMoveCode6111(moveCode6111Item)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']"
								tooltipPosition="top"></button>
							<button pButton icon="pi pi-trash" (click)="confirmDelete(moveCode6111Item)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
	<ng-template #noMoveCode6111s>
		<div class="text-center p-4">
			<i class="pi pi-file-excel text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_MC6'] }}</p>
		</div>
	</ng-template>
</ng-container>